import axios from "axios";

const http = axios.create({
    // baseURL: import.meta.env.VITE_API_URL,
    withCredentials: true,
    headers: {
        "X-Requested-With": "XMLHttpRequest",
        "Accept": "application/json",
        "Content-Type": "application/json",
    },
});

// Если используется CSRF (не Sanctum SPA mode)
const token = document
    .querySelector('meta[name="csrf-token"]')
    ?.getAttribute("content");

if (token) {
    http.defaults.headers.common["X-CSRF-TOKEN"] = token;
}

if (window.Laravel && window.Laravel.locale) {
    http.defaults.headers.common["X-LOCALE"] = window.Laravel.locale;
    http.defaults.headers.common["X-Localization"] = window.Laravel.locale;
}

export default http;
